module.exports = __webpack_public_path__ + "static/img/ent-detail-96.a748fb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-96.jpg
// module id = UUp/
// module chunks = 51